import router from '@/router'

/** @type {boolean} 防止并发请求重复跳转登录页 */
let redirecting = false

/**
 * 判断接口返回是否为 token 失效
 * @param {Object} data 接口响应体
 * @returns {boolean}
 */
export function isTokenInvalidResponse(data) {
  if (!data) {
    return false
  }
  var code = Number(data.code)
  var msg = String(data.msg || data.message || '').toLowerCase()
  return code === 101000 && msg.indexOf('token not valid') !== -1
}

/**
 * 清除登录态并跳转首页登录
 * @returns {void}
 */
export function redirectToLogin() {
  if (redirecting) {
    return
  }
  redirecting = true
  window.localStorage.clear()
  router.replace({
    name: 'Index',
    params: {
      time: new Date().getTime()
    }
  }).finally(function () {
    setTimeout(function () {
      redirecting = false
    }, 1000)
  })
}

/**
 * token 失效时跳转登录页
 * @param {Object} data 接口响应体
 * @returns {boolean} 是否已处理
 */
export function handleTokenInvalidResponse(data) {
  if (isTokenInvalidResponse(data)) {
    redirectToLogin()
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/util/auth.js